module.exports = __webpack_public_path__ + "img/avatar-director.3a7ea22c.svg";